/**
 * Inline icons.
 *
 * Drawn here rather than pulled from a font: the counter app runs on
 * a WebView with no network guarantee, and an icon font that fails to
 * load leaves a nav of empty boxes.
 */
const P: Record<string, string> = {
  board: 'M4 5h7v7H4zM13 5h7v4h-7zM13 11h7v8h-7zM4 14h7v5H4z',
  send: 'M4 12l16-8-6 16-2.5-6.5z',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4-4',
  chat: 'M4 5h16v10H9l-5 4z',
  ticket: 'M5 7h14v4a2 2 0 0 0 0 4v2H5v-2a2 2 0 0 0 0-4z',
  alert: 'M12 4l9 16H3zM12 10v4M12 17h.01',
  card: 'M3 7h18v10H3zM3 11h18',
  cog: 'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM12 2v3M12 19v3'
    + 'M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2',
};

export const Icon = ({ name, size = 17 }: {
  name: string; size?: number;
}) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d={P[name] ?? P.board} />
  </svg>
);
